import { createAsyncThunk } from '@reduxjs/toolkit';
import * as PropertyServices from '~/services/producer/Property';
import { alertRequest } from '../../alert/actions';
import { getErrorResponseMessage } from '~/utils/getErrorResponseMessage';

export const getPropertiesForAll = createAsyncThunk(
  'propertyThunk/getProperties',
  async (propertyFilterParams: any, { dispatch, rejectWithValue }) => {
    try {
      const response = await PropertyServices.fetchPropertiesRequest(
        propertyFilterParams
      );
      return response.results;
    } catch (err: any) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao buscar propriedades.'
      );
      dispatch(alertRequest(errorMessage, 'error'));

      return rejectWithValue(errorMessage);
    }
  }
);
